import { useContext } from "react";
import { ProductContext } from "./ProductProvider";
import { Product } from "src/api/types";

export function useProduct<T>(selector: (product: Product) => T) {
  const product = useContext(ProductContext);

  if (product == null) {
    throw new Error("useProduct is used outside of ProductProvider");
  }

  return selector(product);
}
